import { gql } from '__generated__/gql';
import { gql as apolloGql } from '@apollo/client';

export const LIST_HOTEL_CONTRACTS_QUERY = gql(`
  query ListHotelContracts($hotelId: Int!) {
    hotelContracts(hotelId: $hotelId) {
      id
      hotelId
      type
      validFrom
      validTo
      invoiceInterval
      amountCents
      description
      isActive
      nextInvoiceDate
      sapStatus
      sapLastSyncedAt
      sapError
      createdAt
      updatedAt
      spaceId
    }
  }
`);

export const VIEW_CONTRACT_QUERY = gql(`
  query ViewContract($id: Int!) {
    contract(id: $id) {
      id
      hotelId
      type
      validFrom
      validTo
      invoiceInterval
      amountCents
      description
      isActive
      nextInvoiceDate
      sapStatus
      sapLastSyncedAt
      sapError
      createdAt
      updatedAt
      spaceId
      documents {
        id
        contractId
        filename
        mimeType
        size
        storageKey
        uploadedBy
        createdAt
        updatedAt
      }
      invoiceLogs {
        id
        contractId
        triggeredAt
        invoiceDate
        trigger
        sapStatus
        sapPayloadRef
        error
        createdAt
        updatedAt
      }
    }
  }
`);

export const CREATE_CONTRACT_MUTATION = gql(`
  mutation CreateContract($input: ContractCreateInput!) {
    createContract(input: $input) {
      id
      hotelId
      type
      validFrom
      validTo
      invoiceInterval
      amountCents
      description
      isActive
      nextInvoiceDate
      sapStatus
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_CONTRACT_MUTATION = gql(`
  mutation UpdateContract($id: Int!, $input: ContractUpdateInput!) {
    updateContract(id: $id, input: $input) {
      id
      hotelId
      type
      validFrom
      validTo
      invoiceInterval
      amountCents
      description
      isActive
      nextInvoiceDate
      sapStatus
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_CONTRACT_MUTATION = gql(`
  mutation DeleteContract($id: Int!) {
    deleteContract(id: $id)
  }
`);

export const CREATE_MANUAL_INVOICE_MUTATION = gql(`
  mutation CreateManualInvoice($contractId: Int!, $invoiceDate: String!) {
    createManualInvoice(contractId: $contractId, invoiceDate: $invoiceDate) {
      id
      contractId
      triggeredAt
      invoiceDate
      trigger
      sapStatus
      sapPayloadRef
      error
      createdAt
      updatedAt
    }
  }
`);

export const UPLOAD_CONTRACT_DOCUMENT_MUTATION = gql(`
  mutation UploadContractDocument(
    $contractId: Int!
    $filename: String!
    $base64Data: String!
  ) {
    uploadContractDocument(
      contractId: $contractId
      filename: $filename
      base64Data: $base64Data
    ) {
      id
      contractId
      filename
      mimeType
      size
      storageKey
      uploadedBy
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_CONTRACT_DOCUMENT_MUTATION = gql(`
  mutation DeleteContractDocument($id: Int!) {
    deleteContractDocument(id: $id)
  }
`);

export const CONTRACT_DOCUMENT_URL_QUERY = apolloGql(`
  query ContractDocumentUrl($id: Int!) {
    contractDocumentUrl(id: $id)
  }
`);
